import React, { useState } from 'react';
import * as Yup from 'yup';
import * as moment from 'moment';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';

import AlertModal from 'web/components/AlertModal';

import TextInput from 'web/components/form-elements/TextInput';
import RadioButton from 'web/components/form-elements/RadioButton';


import { Form, Formik, Field } from 'formik';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';

import { Modal,  ModalBody } from 'reactstrap';
import styled from 'styled-components'
import { Container, Body, RecurrencePattern, Heading, BoxWrapper,  RangeofRecurrence, PatternWrapper, RadioData, RadioWrapper } from './requestDateModalStyled'

export default ({ isOpen, toggle, response }) => {
    const [modal, setModal] = useState(false);
    const toggleModal = () => setModal(!modal);
    let recurrenceResponse = response.isRecurring ? response.recurrence : response.postRecurrence

    let setType = recurrenceResponse && recurrenceResponse.pattern && recurrenceResponse.pattern.type
    let monthlyRatio = 'Day'
    const monthlyArr = []
    if (setType === "RELATIVEMONTHLY") {
        setType = "MONTHLY"
        monthlyRatio = 'The'

        monthlyArr.push({
            value: 'The',
            label: 'The',
        })
    } else {
        monthlyArr.push({
            value: 'Day',
            label: 'Day',
        })
    }

    const dayName = (dayName) => {
        if (dayName === "MONDAY") {
            dayName = 'Mon'
        } else if (dayName === "TUESDAY") {
            dayName = 'Tue'
        } else if (dayName === "WEDNESDAY") {
            dayName = 'Wed'
        } else if (dayName === "THURSDAY") {
            dayName = 'Thur'
        } else if (dayName === "FRIDAY") {
            dayName = 'Fri'
        } else if (dayName === "SATURDAY") {
            dayName = 'Sat'
        } else if (dayName === "SUNDAY") {
            dayName = 'Sun'
        }
        return dayName;
    }

    const selectedType = (type) => {
        if (type === 'DAILY') {
            type = 'Daily'
        } else if (type === 'WEEKLY') {
            type = 'Weekly'
        } else if (type === 'MONTHLY') {
            type = 'Monthly'
        }
        return type;
    }
    const dayCounter = (counter) => {
        if (counter === "FIRST") {
            counter = "First"
        } else if (counter === "SECOND") {
            counter = "Second"
        } else if (counter === "THIRD") {
            counter = "Third"
        }
        else if (counter === "FOURTH") {
            counter = "Fourth"
        }
        else if (counter === "LAST") {
            counter = "Last"
        }
        return counter
    }

    const patternArr = [
        {
            value: selectedType(setType),
            label: selectedType(setType),
        },

    ];

    const daysArr = [
        {
            value: recurrenceResponse && recurrenceResponse.pattern && recurrenceResponse.pattern.dayOfWeek,
            label: recurrenceResponse && recurrenceResponse.pattern && recurrenceResponse.pattern.dayOfWeek,
        },
    ];

    const INITIAL_VALUES = {
        requestDeliveryDate: moment(response.requestDeliveryDate).format(FORMAT),
        type: selectedType(setType),
        interval: recurrenceResponse && recurrenceResponse.pattern && recurrenceResponse.pattern.interval,
        endAfterOccurrences: recurrenceResponse && recurrenceResponse.range && recurrenceResponse.range.endAfterOccurrences,
        endBy: recurrenceResponse && recurrenceResponse.range && recurrenceResponse.range.endBy || '',
        dayOfWeek: recurrenceResponse && recurrenceResponse.pattern && recurrenceResponse.pattern.dayOfWeek || '',

        noDay: recurrenceResponse && recurrenceResponse.pattern && recurrenceResponse.pattern.dayOfMonth,
        index: recurrenceResponse && recurrenceResponse.pattern && dayCounter(recurrenceResponse.pattern.index),
        daysdropDown: recurrenceResponse && recurrenceResponse.pattern && dayName(recurrenceResponse.pattern.dayOfWeek),
        monthlyRadio: monthlyRatio
    }
    const VALIDATION_SCHEMA = Yup.object().shape({
    });

    const everyCall = (firstTitle, lastTitle, classNameSet) => {
        return <DailyWrapper >
            <div>
                <p className='mt-0' >{firstTitle}</p>
            </div>
            <div>
                <TextInput
                    name={classNameSet}
                    inputType="text"
                    placeholder='Street Address 1'
                    showErrorMessages={true}
                    disabled={true}
                />
                <p className='mt-0' >{lastTitle}</p>
            </div>
        </DailyWrapper>
    }

    const dailyCall = (props) => {
        return <><div className="row mx-0">
            {everyCall('Every', 'day(s)', 'interval')}
        </div>
        </>
    }
    const rangeOfRecurrence = () => {
        return <div className=" mx-0">
            <Heading><h6>Range of recurrence</h6></Heading>

            <div>
                <PatternWrapper>
                    <div>
                        <EndAfter>
                            {recurrenceResponse.range.endAfterOccurrences && <><TextInput
                                name='endAfterOccurrences'
                                placeholder=''
                                showErrorMessages={true}
                                disabled={true}
                            />

                                <p className='mt-0'>Occurrences</p></>}
                            {recurrenceResponse.range.endBy && <>
                                <TextInput
                                    name='endBy'
                                    placeholder=''
                                    showErrorMessages={true}
                                    disabled={true}
                                />
                                <p className='mt-0'>End Date</p>
                            </>
                            }
                        </EndAfter>

                    </div>
                </PatternWrapper>
            </div>

        </div>
    }
    const weeklyCall = (props) => {
        return <><div className=" mx-0">
            <div>{everyCall('Recur every', 'week(s) on:', 'interval')}</div>
            <WeeklyDays>{recurrenceResponse.pattern.daysOfWeek.map((value, index) => (
                <div key={index}>
                    <p>{value}</p>
                </div>
            ))}</WeeklyDays>
        </div>
        </>
    }

    const monthlyCall = (props) => {
        return <>
            <TheDaySection>
                <div>{monthlyArr &&
                    monthlyArr.map((value, index) => (
                        <div key={index}>
                            <Field
                                component={RadioButton}
                                name='monthlyRadio'
                                id={value.value}
                                defaultValue={monthlyArr[0].value}
                                onSelect={(e) => {
                                }}
                                label={value.label}
                            />
                        </div>
                    ))}</div>
                <div>
                    {recurrenceResponse.pattern.interval && <NoDay>
                        <div className='app-input-text'>
                            <TextInput
                                name='noDay'
                                placeholder=''
                                showErrorMessages={true}
                                disabled={true}
                            />

                        </div>
                        {everyCall('of every', 'month(s)', 'interval')}
                    </NoDay>}

                    {!recurrenceResponse.pattern.interval && <TheDay>
                        <TextInput
                            name='index'
                            placeholder=''
                            showErrorMessages={true}
                            disabled={true}
                        />
                        <TextInput
                            name='daysdropDown'
                            placeholder=''
                            showErrorMessages={true}
                            disabled={true}
                        />
                        {everyCall('of every', 'month(s)', 'noDay')}
                    </TheDay>}
                </div>
            </TheDaySection>
        </>
    }


    return (
        <div className='alert-modal'>
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                backdrop={'static'}
                centered={true}
                fullscreen='fullscreen'
                className="recurranceModal"
            >
                <div className='modal-content'>
                    <div className='header'>
                        <Button handleClick={() => {
                            toggle(!isOpen)
                        }}>
                            <img src={CloseIcon} className="closeIcon" alt="close-icon" />
                        </Button>
                        <h3>{response.isPostRecurring ? "Individual post recurrence" : "Committed order recurrence"}</h3>
                    </div>
                    <ModalBody>
                        <div className='placeBidBody'>
                            <Formik
                                initialValues={INITIAL_VALUES}
                                validationSchema={VALIDATION_SCHEMA}
                                onSubmit={(values) => { }}>
                                {(props) => {
                                    const { isValid, dirty, values, errors, touched, setFieldValue } = props;
                                    return (
                                        <>
                                            <Form>
                                                <Container>
                                                    <Body>
                                                        <RecurrencePattern>
                                                            <Heading><h6>Recurrence Pattern</h6></Heading>
                                                            <BoxWrapper>
                                                                <PatternWrapper>
                                                                    <RadioWrapper>
                                                                        {patternArr &&
                                                                            patternArr.map((value, index) => (
                                                                                <div key={index}>
                                                                                    <Field
                                                                                        component={RadioButton}
                                                                                        name='type'
                                                                                        id={value.value}
                                                                                        defaultValue={patternArr[0].value}
                                                                                        onSelect={(e) => {
                                                                                        }}
                                                                                        label={value.label}
                                                                                    />
                                                                                </div>
                                                                            ))}
                                                                    </RadioWrapper>
                                                                    <RadioData>
                                                                        {recurrenceResponse.pattern.type === "DAILY" && dailyCall(props)}
                                                                        {recurrenceResponse.pattern.type === "WEEKLY" && weeklyCall(props)}
                                                                        {recurrenceResponse.pattern.type === "MONTHLY" && monthlyCall(props)}
                                                                        {recurrenceResponse.pattern.type === "RELATIVEMONTHLY" && monthlyCall(props)}
                                                                    </RadioData>
                                                                </PatternWrapper>
                                                            </BoxWrapper>
                                                        </RecurrencePattern>
                                                        <RangeofRecurrence>
                                                            <BoxWrapper>
                                                                {rangeOfRecurrence()}
                                                            </BoxWrapper>
                                                        </RangeofRecurrence>
                                                        <ActionBtn> </ActionBtn>
                                                    </Body>
                                                </Container>
                                            </Form>
                                        </>
                                    );
                                }}
                            </Formik>
                        </div>
                    </ModalBody>
                </div>
            </Modal>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                content=''
                link=''
            />
        </div>
    );
};
const DailyWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    > div {
      display: flex;
    align-items: center;
        gap: 10px;

    .app-input-text {
      margin: 0;
      input {
        max-width: 54px;
    text-align: center;
      }
    }
    }
`

const EndAfter = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
 .app-input-text {
      max-width: 124px;
    }
    > p {
      margin-bottom: 20px;
    }
`

const EndRadioWrapper = styled.div`
    display: flex;
    width: 100px;
    flex-direction: column;
    align-items: flex-start;
    
    > div {
        margin: 9px 0;
    }
`
const StartWrapper = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
    padding-left: 0;
    margin-bottom: 15px;
 > div {
   :first-child {
    width: 85px;
    text-align: left;
   }
 }
`

const ActionBtn = styled.div`
 display: flex;
     margin: 15px 0;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    flex-wrap: wrap;
    > button {
      height: 38px;
    width: 90px;
    }

`

const WeeklyDays = styled.div`    
    display: flex;
    flex-wrap: wrap;
    grid-column-gap: 15px;
    margin: 15px 0;
      > div {
        min-width: 100px;
        text-align: left;
      }
      @media (max-width:495px) {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
    `

const TheDaySection = styled.div`
  display: flex;
  > div {
    flex:1;
    :first-child {
      max-width: 100px;
      text-align: left;
      > div {
            margin-bottom: 15px;
      }
    }
  }
`
const NoDay = styled.div`
  display: flex;
  gap: 15px;
      margin-bottom: 15px;
      p {
        margin:0;
      }
  .app-input-text {
    margin: 0;
        flex: 1;
    max-width: 54px;
    input {
      text-align: center;
    }
  }

`

const TheDay = styled.div`
  display: flex;
  gap: 10px;
  p {
    margin:0;
  }
  > div {
    flex:1;
    :first-child {
      max-width: 120px;
    }
    :nth-child(2) {
      max-width: 100px;
    }
  }

`